
import {Vue, Component} from 'vue-property-decorator'
import PropertySearchField from '@/components/properties/PropertySearchField.vue'

@Component({metaInfo: {title:process.env.VUE_APP_NAME + " - Properties dashboard"}, components : {PropertySearchField}})
export default class PropertiesView extends Vue {

}
